<div class="assets-container" *appHasPermission="[{ resource: Resources.Assets, scope: Scopes.Read }]">
  <div class="assets-header">
    <div class="title-container">
      <div class="inner-tab-title">Assets</div>
    </div>
  </div>
  <form class="form-container" (submit)="onGenerate($event)">
    <h3>Generate Assets Report</h3>
    <div class="form-group date-group">
      <app-date-picker
        [datePickerMode]="'dropdown'"
        [styleDropdown]="'custom'"
        [reduceMaxDate]="1"
        [allowSingleInRange]="true"
        [showActions]="true"
        [dateFilter]="dateFilter"
        (rangeChange)="onDateRangeSelected($event)"
      ></app-date-picker>
    </div>

    <div class="form-group merchant-group">
      <app-dropdown
        label="Merchant"
        placeholder="Select merchant"
        [options]="merchantOptions"
        [(ngModel)]="selectedMerchantId"
        (ngModelChange)="onMerchantSelected($event)"
        name="assetMerchant"
        [loading]="merchantsLoading"
        [disabled]="merchantsLoading || isLoading"
        [isSearch]="true"
        searchPlaceholder="Search merchants"
      ></app-dropdown>
    </div>
    <app-button
      *appHasPermission="{ resource: Resources.Reports, scope: Scopes.Export }"
      buttonVariant="report-export"
      buttonType="submit"
      [state]="generateButtonState"
    >
      <img src="shared-assets/icons/download.png" alt="Export Icon" class="icon" />
      <span>Generate</span>
    </app-button>
  </form>
</div>
